// extracted by mini-css-extract-plugin
var _1 = "PageCheckout__link--AfHKk OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _2 = "PageCheckout__loadingContainer--IUb7e";
var _3 = "PageCheckout__main--nCRzJ";
var _4 = "PageCheckout__mainContent--CvEnF";
var _5 = "PageCheckout__mainLoading--g_muV PageCheckout__main--nCRzJ";
var _6 = "PageCheckout__shippingNotice--BFYU2";
var _7 = "PageCheckout__topError--lSNTx OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE OfficeGeneral__textSizeB--Ye78Y CoreGeneral__textSizeB--joAuE";
export { _1 as "link", _2 as "loadingContainer", _3 as "main", _4 as "mainContent", _5 as "mainLoading", _6 as "shippingNotice", _7 as "topError" }
